/**
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
export default {
    "us_mall": {
        "feature_one": "Free, fast shipping",
        "feature_two": "Free, easy return",
        "feature_three": "6-Month Warranty",
        "quantity": "数量：",
        "tax_tips": "Tax caculation",
        "buy": "立即购买",
        "check_out": "结算",
        "select_one": "请选择一条数据",
        "free_shipping": "免运费",
    },
    "product": {
        "choose_device_title": "请选择你需要购买的设备类型",
        "choose_package_title": "请选择配套的流量套餐",
        "add_to_cart": "加入购物车",
        "suc": "成功",
        "err": "失败"
    },
    "cart": {
        "pc_cart_title": "我的购物车",
        "cart_title": "购物车",
        "remove": "移除",
        "total": "合计:",
        "noCart_title": "您的购物车已空!",
        "noCart_subTitle": "登录查看是否有已选中的商品，或继续购物",
        "sign": "重新登录",
        "shopping": "继续购物",
        "select_product": "请勾选需要结算的商品"
    },
    "settlement": {
        "title": "SECURE CHECKOUT",
        "delivery": "Delivery",
        "pick_up": "Pick up",
        "form_title": "输入您的收件信息",
        "province": "省份",
        "city": "城市",
        "district": "区域",
        "required": "此为必填项",
        "firstName": "First name",
        "lastName": "Last name",
        "address1": "Address line 1",
        "address2": "Address line 2",
        "state": "State/Province/Region",
        "zipCode": "Zip code",
        "contactInfo": "Contact information",
        "customerName": "收件人",
        "phone": "手机号码",
        "detailed_Address": "详细地址",
        "payMethod_title": "支付方式",
        "payMth_weChat": "微信支付",
        "contact_checked": "Subscribe to our news letter to receive exclusive deals",
        "ship": "Shipping method",
        "payment": "Payment method",
        "pickup_spot": "Available pickup spot",
        "name": "Name",
        "order_summary": "订单汇总",
        "apply": "Apply",
        "subtotal": "商品总价",
        "shipping": "运费：",
        "tax": "Tax",
        "total": "合计:",
        "privacy": "By placing this order, you agree to our<a href=\"/member/agreement\">Terms and Conditions</a> and <a href=\"/users/privacy_policy\">Privacy Policy</a>.",
        "order": "提交订单",
        "paymentCompleted": "已完成付款",
        "wxScanTips": "请使用微信扫一扫付款",
        "payForWeChat": "微信支付",
        "exchange": "兑换",
        "remove": "移除",
        "exchangeSuc": "兑换码已成功兑换",
        "exchangeFail": "请输入有效的兑换码",
        "invalidCoupon": "无效的优惠券",
        "notExistCoupon": "优惠券码不存在或已失效",
        "ExpiredCoupon": "优惠券使用次数超出限制或已过期",
        "InvalidCode": "无效码"
    },
    "cooperation": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "position": "Position",
        "companyName": "Company Name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "productInterst": "Main Product of Interest",
        "estimatedQuantity": "Estimated Quantity of Product",
    }
}



// WEBPACK FOOTER //
// ./src/lang/zh/usmall.js